(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const el = selector => root.querySelector(selector);
    const strings = JSON.parse(el('[data-offer-strings]').textContent);
    const form = el('form');
    const quantity = el('[data-quantity]');
    const width = el('[data-width]');
    const height = el('[data-height]');
    const art = el('[data-art]');
    const buy = el('[data-buy]');
    const add = el('[data-add-cart]');
    const error = el('[data-error]');
    const ready = el('[data-ready]');
    const deadline = Date.parse(root.dataset.end);
    const storageKey = 'pt-halloween-pending-v2';
    const submission = crypto.randomUUID();
    let busy = false;
    let pending = false;
    let added = false;
    const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    const selected = () => quantity.selectedOptions[0];
    const validSize = () => [width, height].every(input => Number(input.value) >= 0.5 && Number(input.value) <= 4 && input.validity.valid);
    const fileValid = () => {
      const f = art.files[0];
      return !!f && f.size > 0 && f.size <= 20 * 1024 * 1024 && /\.(png|jpe?g|pdf|ai|eps|svg)$/i.test(f.name);
    };
    const eligible = () => {
      const option = selected();
      return root.dataset.enabled === 'true' && root.dataset.currency === 'USD' && Number.isFinite(deadline) && Date.now() < deadline && option?.dataset.available === 'true' && /^\d+$/.test(option.value) && Number(option.dataset.count) >= 100 && Number(option.dataset.price) === Number(option.dataset.count) * 210;
    };
    const controls = Array.from(form.querySelectorAll('input,select,textarea'));
    const lock = value => controls.forEach(input => { input.disabled = value; });
    function update() {
      const option = selected();
      const count = Number(option?.dataset.count || 100);
      el('[data-summary-count]').textContent = count;
      el('[data-patch-count]').value = count;
      el('[data-dimensions]').textContent = `${width.value || '—'} × ${height.value || '—'} in`;
      el('[data-total]').textContent = money(Number(option?.dataset.price || 21000));
      buy.disabled = add.disabled = busy || pending || added || !eligible() || !validSize() || !fileValid();
      if (busy || pending || added) return;
      ready.textContent = !eligible() ? (Date.now() >= deadline ? strings.expired : strings.unavailable) : !validSize() ? strings.sizeError : !fileValid() ? (art.files.length ? strings.fileError : strings.artError) : strings.ready;
      el('[data-file-status]').textContent = art.files.length ? `${strings.fileSaved} ${art.files[0].name}` : '';
    }
    function review(message) {
      error.textContent = message + ' ';
      const link = document.createElement('a');
      link.href = root.dataset.cartUrl;
      link.textContent = strings.reviewCart;
      error.append(link);
    }
    async function readCart() {
      const response = await fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error(strings.recovery);
      return response.json();
    }
    function savePending(value) {
      try { value ? sessionStorage.setItem(storageKey, value) : sessionStorage.removeItem(storageKey); } catch (_) {}
    }
    async function recover() {
      let prior;
      try { prior = sessionStorage.getItem(storageKey); } catch (_) {}
      if (!prior) return;
      pending = true;
      update();
      try {
        const cart = await readCart();
        const existing = cart.items.find(item => item.properties?.['_Promotion submission'] === prior);
        if (existing) { added = true; lock(true); review(strings.recovery); }
        else savePending(null);
        pending = false;
      } catch (_) { review(strings.recovery); }
      update();
    }
    form.addEventListener('input', () => {
      art.setCustomValidity('');
      if (!pending && !added) error.textContent = '';
      update();
    });
    form.addEventListener('change', update);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || pending || added || !eligible() || !validSize()) return update();
      art.setCustomValidity(fileValid() ? '' : strings.fileError);
      if (!form.reportValidity() || !fileValid()) return update();
      const option = selected();
      const expected = Number(option.dataset.price);
      const variantId = Number(option.value);
      const destination = event.submitter === add ? root.dataset.cartUrl : (window.Shopify?.routes?.root || '/') + 'checkout';
      const data = new FormData(form);
      data.set('quantity', '1');
      data.set('properties[_Promotion submission]', submission);
      busy = true;
      error.textContent = '';
      ready.textContent = strings.uploading;
      buy.textContent = strings.sending;
      update();
      lock(true);
      savePending(submission);
      let rejected = false;
      try {
        const response = await fetch(root.dataset.addUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        if (!response.ok) {
          rejected = true;
          const result = await response.json().catch(() => ({}));
          throw new Error(result.description || strings.cartError);
        }
        const cart = await readCart();
        const line = cart.items.find(item => item.properties?.['_Promotion submission'] === submission);
        added = !!line;
        if (!line || cart.currency !== 'USD' || line.variant_id !== variantId || line.quantity !== 1 || line.original_line_price !== expected || line.final_line_price !== expected || !line.properties?.Artwork || !eligible()) throw new Error(strings.cartError);
        window.location.assign(destination);
      } catch (failure) {
        if (rejected) {
          savePending(null);
          lock(false);
          error.textContent = failure.message;
        } else {
          pending = true;
          review(failure.message || strings.recovery);
        }
      } finally {
        busy = false;
        buy.textContent = strings.buy;
        update();
      }
    });
    function tick() {
      if (!root.isConnected) return clearInterval(timer);
      if (Number.isFinite(deadline) && Date.now() >= deadline) {
        el('#promotion-heading').textContent = strings.expiredHeading;
        root.classList.add('offer-ended');
      }
      update();
    }
    update();
    recover();
    const timer = setInterval(tick, 1000);
  }
  document.querySelectorAll('[data-offer]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-offer]').forEach(init));
})();
